// extracted by mini-css-extract-plugin
module.exports = {"default":"idt-input_default__1eys_","small":"idt-input_small__zhtdh","invalid":"idt-input_invalid__12jw3","input":"idt-input_input__2xbyr","feedback":"idt-input_feedback__1ym-6"};